'use client';

import { DollarSign, ArrowUpRight, ArrowDownRight, Trophy, Users } from 'lucide-react';
import { StatsCard } from '@/core/presentation/components/StatsCard';
import { kpiData, mockPlans, revenueChartData } from '@/features/admin/presentation/data/mockData';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

const PLAN_COLORS = ['#0D1B5E', '#1A2E7A', '#4AB8E0', '#7ECFEF', '#B8E8F7'];

export function DashboardFinanceiro() {
  const usersByPlanData = mockPlans.map((plan) => ({ name: plan.name, value: plan.users }));
  const topPlan = mockPlans.reduce((acc, plan) => (plan.users > acc.users ? plan : acc), mockPlans[0]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
        <StatsCard
          title="Receita total"
          value="R$ 293k"
          icon={<DollarSign className="h-5 w-5 text-admin-cyan-dark" />}
          trend={8.3}
          gradient
        />
        <StatsCard
          title="Despesas"
          value="R$ 141k"
          icon={<ArrowDownRight className="h-5 w-5 text-admin-cyan-dark" />}
          trend={-2.1}
        />
        <StatsCard
          title="Lucro líquido"
          value="R$ 152k"
          icon={<ArrowUpRight className="h-5 w-5 text-admin-cyan-dark" />}
          trend={14.2}
        />
        <StatsCard
          title="Ticket médio"
          value={kpiData.avgTicket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          icon={<DollarSign className="h-5 w-5 text-admin-cyan-dark" />}
          trend={2.8}
        />
        <StatsCard
          title="Plano mais adquirido"
          value={topPlan.name}
          icon={<Trophy className="h-5 w-5 text-admin-cyan-dark" />}
          subtitle={`${topPlan.users.toLocaleString('pt-BR')} usuários`}
        />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        <div className="xl:col-span-2 bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">
            Receita vs Despesas por mês
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={revenueChartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2EAF8" />
              <XAxis dataKey="month" tick={{ fontSize: 12, fill: '#718096' }} />
              <YAxis tick={{ fontSize: 12, fill: '#718096' }} />
              <Tooltip />
              <Legend />
              <Bar dataKey="receita" fill="#0D1B5E" radius={[4, 4, 0, 0]} />
              <Bar dataKey="despesas" fill="#7ECFEF" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">Distribuição de usuários por plano</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={usersByPlanData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={{ fontSize: 12, fill: '#2D3748' }}
              >
                {usersByPlanData.map((_, i) => (
                  <Cell key={i} fill={PLAN_COLORS[i % PLAN_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
          <div className="mt-2 flex items-center gap-2 text-xs text-admin-text-secondary">
            <Users className="h-4 w-4 text-admin-cyan-dark" />
            Base total: {usersByPlanData.reduce((acc, plan) => acc + plan.value, 0).toLocaleString('pt-BR')} usuários
          </div>
        </div>
      </div>
    </div>
  );
}

